import React from 'react';

import { TWO_D_REPORT_RIGHT_COLUMN_ID } from '../..';

import styles from './ReportLayout.module.scss';

type BasicProps = {
  children: React.ReactNode;
} & React.ComponentProps<'div'>;

export const Container = ({ children, ...rest }: BasicProps) => {
  return (
    <div className={styles.container} {...rest}>
      {children}
    </div>
  );
};

export const Main = ({ children, ...rest }: BasicProps) => (
  <main className={styles.main} {...rest}>
    {children}
  </main>
);

export const LeftColumn = ({ children, ...rest }: BasicProps) => (
  <div className={styles.leftColumn} {...rest}>
    {children}
  </div>
);

export const RightColumn = ({ children, ...rest }: BasicProps) => {
  return (
    <div
      id={TWO_D_REPORT_RIGHT_COLUMN_ID}
      className={styles.rightColumn}
      {...rest}
    >
      {children}
    </div>
  );
};
